<template>
    <div>

      <Card>
        <Row :gutter="24">
            <Col span="3">
              <Button type="primary" @click="add">新增</Button>
            </Col>
            <Col span="3">
                <Input v-model="params.name" @on-change="getSoftwareAssetsPrice">
                    <span slot="prepend">申请人</span>
                </Input>
            </Col>
            <Col span="3">
                <Input v-model="params.company" @on-change="getSoftwareAssetsPrice">
                    <span slot="prepend">厂商</span>
                </Input>
            </Col>
            <Col span="3">
                <Input v-model="params.authorization_type" @on-change="getSoftwareAssetsPrice">
                    <span slot="prepend">类型</span>
                </Input>
            </Col>
            <Col span="3">
                <Button type="text" icon="md-refresh-circle" @click="getSoftwareAssetsPrice"></Button>
            </Col>
        </Row>
      </Card>

      <Table highlight-row ref="currentRowTable" :columns="priceColumns" :data="assetList"></Table>
      <Page :total="count" :current="params.page" show-sizer show-total :page-size="params.size" @on-change="currentHandle" @on-page-size-change="pageSizeHandle"></Page>

      <Drawer
        :title="formItem.id ? '编辑' : '新增'"
        v-model="drawerChange"
        width="672"
        :mask-closable="false"
        @on-close="drawerChange=false"
      >
        <i-form ref="formItem" :model="formItem" :label-width="80" :rules="ruleValidate">
          <form-item label="软件名称" prop="name">
            <i-input v-model="formItem.name" placeholder=""></i-input>
          </form-item>

          <form-item label="类型" prop="authorization_type">
            <Select v-model="formItem.authorization_type" style="width:200px">
              <Option  value="按年" >按年</Option>
              <Option  value="永久" >永久</Option>
            </Select>
          </form-item>

          <form-item label="厂商" prop="company">
            <i-input v-model="formItem.company" placeholder=""></i-input>
          </form-item>
          <form-item label="价格" prop="price">
            <i-input v-model="formItem.price" placeholder=""></i-input>
          </form-item>
          <form-item label="币别" prop="currency">
            <Select v-model="formItem.currency" style="width:100%">
              <Option v-for="item in countryList" :value="item.name" :key="item.name">
                {{ item.name }}
                  <!-- <span style="float:right;color:#ccc">{{ item.name }}</span> -->
              </Option>
            </Select>
          </form-item>
          <form-item label="备注" prop="remark">
            <i-input v-model="formItem.remark" placeholder=""></i-input>
          </form-item>

          <form-item>
            <i-button type="primary" @click="handleSubmit('formItem')">提交</i-button>
            <i-button style="margin-left: 8px" @click="drawerChange=false">取消</i-button>
          </form-item>
        </i-form>
        <spin fix v-if="changeLoadingShow">
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>请求中....</div>
        </spin>
      </Drawer>

      <Modal
          v-model="logModal"
          title="日志"
          :mask-closable="false"
          :scrollable="true">

          <template>
            <Timeline>
                <TimelineItem :color="item.content.indexOf('新增') !== -1 ? 'green' : 'red'" v-for="(item, index) in logs" :key="index">
                  <p class="time">{{ item.created_at}}</p>
                  <p class="content">{{ item.content}}</p>
                  <p class="content">{{ item.remark}}</p>
                </TimelineItem>
            </Timeline>
          </template>
      </Modal>

    </div>
</template>

<script>
import moment from 'moment'
import { getSoftwareAssetsPrice, addSoftwareAssetsPrice, updateSoftwareAssetsPrice, deleteSoftwareAssetsPrice, addSoftwareAssetsLog, getSoftwareAssetsLog } from '@/api/cmdb'
export default {
  name: 'softwarePrice',
  data () {
    return {
      formItem: {
        name: null,
        company: null,
        price: null,
        currency: 'CNY - 人民币',
        authorization_type: '按年',
        update_user: this.$store.state.user.userId,
        remark: null
      },
      formItemSource: {},
      logs: [],
      ruleValidate: {
        name: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ]
      },
      priceColumns: [
        {
          width: 60,
          align: 'center',
          key: 'id',
          ellipsis: true,
          tooltip: true
        },
        {
          title: '软件名称',
          key: 'name',
          align: 'center',
          minWidth: 200,
          ellipsis: true,
          tooltip: true,
          render: (h, params) => {
            return h('a', {
              props: {
                type: 'warning',
                size: 'small'
              },
              on: {
                click: () => {
                  this.logModal = true
                  getSoftwareAssetsLog({ software_assets_price_id: params.row.id, page: 1, size: 1000 }).then(rsp => {
                    const { results } = rsp.data
                    this.logs = results
                  })
                }
              }
            }, params.row.name)
          }
        },

        {
          title: '厂商',
          key: 'company',
          align: 'center',
          minWidth: 120,
          ellipsis: true,
          tooltip: true
        },

        {
          title: '价格',
          key: 'price',
          align: 'center',
          minWidth: 120,
          ellipsis: true,
          tooltip: true
        },

        {
          title: '币别',
          key: 'currency',
          align: 'center',
          minWidth: 150,
          ellipsis: true,
          tooltip: true
        },

        {
          title: '授权类别',
          key: 'authorization_type',
          ellipsis: true,
          tooltip: true,
          minWidth: 100,
          render: (h, params) => {
            return h('div', [
              h('Tag', {
                props: {
                  color: params.row.authorization_type === '按年' ? '#7232dd' : params.row.authorization_type === '永久' ? 'red' : 'red'
                }
              }, params.row.authorization_type)
            ])
          }
        },

        {
          title: '维护人',
          key: 'update_user_info',
          ellipsis: true,
          tooltip: true,
          minWidth: 100,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Tag', {
              }, params.row.update_user_info.name)
            ])
          }
        },

        {
          title: '创建时间',
          key: 'created_at',
          align: 'center',
          tooltip: true,
          minWidth: 200,
          render: (h, params) => {
            if (params.row.created_at) {
              return h('span', moment(params.row.created_at).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              return ''
            }
          }
        },

        {
          title: '修改时间',
          key: 'updated_at',
          align: 'center',
          tooltip: true,
          minWidth: 200,
          render: (h, params) => {
            if (params.row.updated_at) {
              return h('span', moment(params.row.updated_at).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              return ''
            }
          }
        },

        {
          title: '备注',
          key: 'remark',
          minWidth: 200,
          ellipsis: true,
          tooltip: true
        },
        {
          title: '操作',
          align: 'center',
          fixed: 'right',
          width: 200,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.formItem = params.row
                    this.formItemSource = { ...params.row }
                    this.drawerChange = true
                  }
                }
              }, '编辑'),
              h('Poptip', {
                props: {
                  confirm: true,
                  transfer: true,
                  placement: 'bottom',
                  title: '你确定要删除吗?'
                },
                style: {
                  display: this.$store.state.user.superuser ? 'inline-block' : 'none'
                },
                on: {
                  'on-ok': () => {
                    deleteSoftwareAssetsPrice({ id: params.row.id }).then(_ => {
                      this.getSoftwareAssetsPrice()
                    })
                  }
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  }
                }, '删除')
              ])
            ])
          }
        }

      ],
      params: { page: 1, size: 10 },
      assetList: [],
      count: 0,
      drawerChange: false,
      changeLoadingShow: false,
      logModal: false,
      countryList: [
        { id: '1', key: 'CNY', name: 'CNY - 人民币' },
        { id: '2', key: 'USD', name: 'USD - 美元' },
        { id: '3', key: 'EUR', name: 'EUR - 欧元' },
        { id: '4', key: 'GBP', name: 'GBP - 英镑' },
        { id: '5', key: 'JPY', name: 'JPY - 日元' },
        { id: '6', key: 'HKD', name: 'HKD - 港币' },
        { id: '7', key: 'AUD', name: 'AUD - 澳元' },
        { id: '8', key: 'CAD', name: 'CAD - 加元' }
      ]
    }
  },
  mounted () {
    this.getSoftwareAssetsPrice()
  },
  methods: {

    add () {
      this.drawerChange = true
      this.formItem = {
        name: null,
        company: null,
        price: null,
        currency: 'CNY - 人民币',
        authorization_type: '按年',
        update_user: this.$store.state.user.userId,
        remark: null
      }
    },

    getSoftwareAssetsPrice () {
      getSoftwareAssetsPrice(this.params).then(rsp => {
        const { results, count } = rsp.data
        this.assetList = results
        this.count = count
      })
    },

    currentHandle (page) {
      this.params.page = page
      this.getSoftwareAssetsPrice()
    },

    pageSizeHandle (size) {
      this.params.size = size
      this.getSoftwareAssetsPrice()
    },

    handleSubmit (name) {
      let that = this.formItem
      let remark = {}
      this.$refs[name].validate((valid) => {
        if (valid) {
          Object.keys(this.formItem).forEach(_key => {
            if (this.formItem[_key] !== this.formItemSource[_key]) {
              remark[_key] = `${this.formItemSource[_key]} -> ${this.formItem[_key]}`
            }
          })
          this.changeLoadingShow = true
          if (that.id) {
            if (Object.keys(remark).length !== 0) {
              updateSoftwareAssetsPrice(that).then(rsp => {
                const { data } = rsp
                this.getSoftwareAssetsPrice()
                addSoftwareAssetsLog({ log_type: '软件价格', content: '修改', operator_id: this.$store.state.user.userId, software_assets_price: data.id, remark: JSON.stringify(remark) })
                this.changeLoadingShow = false
                this.drawerChange = false
                this.$Notice.success({ title: '修改成功' })
              }).catch(err => {
                this.$Notice.error({ title: err })
                this.changeLoadingShow = false
              })
            } else {
              this.changeLoadingShow = false
              this.drawerChange = false
              this.$Notice.error({ title: '无数据变化！' })
            }
          } else {
            addSoftwareAssetsPrice(that).then(rsp => {
              const { data } = rsp
              this.getSoftwareAssetsPrice()
              addSoftwareAssetsLog({ log_type: '软件价格', content: '新增', operator_id: this.$store.state.user.userId, software_assets_price: data.id, remark: JSON.stringify(this.formItem) })
              this.changeLoadingShow = false
              this.drawerChange = false
              this.$Notice.success({ title: '添加成功' })
            }).catch(err => {
              this.$Notice.error({ title: err })
              this.changeLoadingShow = false
            })
          }
        } else {
          this.changeLoadingShow = false
          this.drawerChange = false
          this.$Notice.error({ title: '请检查输入框！' })
        }
      })
    }

  }
}
</script>
